<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 28 28">
  <path d="M13.996 17.704c-5.032 0-9.33.793-9.33 3.967s4.271 3.996 9.33 3.996c5.032 0 9.33-.793 9.33-3.967 0-3.175-4.27-3.996-9.33-3.996"/>
  <path d="M13.996 14.681a6.152 6.152 0 0 0 6.174-6.174 6.152 6.152 0 0 0-6.174-6.174 6.153 6.153 0 0 0-6.174 6.174 6.153 6.153 0 0 0 6.174 6.174" opacity=".4"/>
</svg>
